import React, { useState } from "react";
// Eliminamos imports de botones y useEffect manual
import InputNumberNoScroll from "../../../components/inputs/inputNumberNoScroll";
import CertificadoAutocomplete from "../../../components/autocomplete/CertificadoAutocomplete";
import ProductoAutocomplete from "../../../components/autocomplete/ProductoAutocomplete";
import DrawerFilter from "../../../components/listing/DrawerFilter";

export default function FiltroProdCertificado({
  initialFilters = {},
  onSubmit = () => {},
  onClose = () => {},
}) {
  // --- ESTADOS DE FILTROS ---
  const [certificadoObj, setCertificadoObj] = useState(null);
  const [productoObj, setProductoObj] = useState(null);
  
  const [qnProducto, setQnProducto] = useState(initialFilters.qnProducto || "");
  const [valorMontoDescuento, setValorMontoDescuento] = useState(initialFilters.valorMontoDescuento || "");
  
  // Se mantiene el estado aunque no tenga input visual en el original, 
  // para no romper la estructura del objeto enviado.
  const [qnUtilizado] = useState(initialFilters.qnUtilizado || ""); 

  const [isLoading, setIsLoading] = useState(false);

  // --- SUBMIT ---
  const handleApply = () => {
    setIsLoading(true);
    
    onSubmit({
      // Extraemos solo el ID de los objetos seleccionados
      certificadoId: certificadoObj?.id || "",
      productoId: productoObj?.id || "",
      qnProducto: qnProducto,
      valorMontoDescuento: valorMontoDescuento,
      qnUtilizado: qnUtilizado,
    });

    setIsLoading(false);
    onClose();
  };

  return (
    <DrawerFilter
      title="Filtros de Productos" // Mantenemos el título original
      onClose={onClose}
      onApply={handleApply}
      isLoading={isLoading}
    >
      {/* 1. Impuesto al Valor Selectivo (Certificado) */}
      <div>
        <label className="form-label-fil">Impuesto al Valor Selectivo (Certificado):</label>
        <div className="mt-1 w-full">
          <CertificadoAutocomplete
            value={certificadoObj}
            onChange={(obj) => setCertificadoObj(obj)}
            placeholder="Buscar por Nro..."
          />
        </div>
      </div>

      {/* 2. Producto */}
      <div>
        <label className="form-label-fil">Producto:</label>
        <div className="mt-1 w-full">
          <ProductoAutocomplete
            value={productoObj}
            onChange={(obj) => setProductoObj(obj)}
            placeholder="Buscar por código o nombre..."
          />
        </div>
      </div>

      {/* Separador Visual */}
      <div className="border-t border-gray-200 my-2"></div>

      {/* 3. Cant. del producto */}
      <div>
        <label className="form-label-fil">Cant. del producto:</label>
        <InputNumberNoScroll 
          className="input mt-1 w-full" 
          value={qnProducto} 
          onChange={(e) => setQnProducto(e.target.value)} 
          placeholder="Ej: 100"
        />
      </div>

      {/* 4. Monto del Descuento */}
      <div>
        <label className="form-label-fil">Monto del Descuento:</label>
        <InputNumberNoScroll 
          className="input mt-1 w-full" 
          value={valorMontoDescuento} 
          onChange={(e) => setValorMontoDescuento(e.target.value)} 
          placeholder="Ej: 5000"
        />
      </div>

    </DrawerFilter>
  );
}